import React, { useState, useEffect } from "react";
import SellerProducts from "./SellerProducts";
import SellerRFQs from "./SellerRFQs";
import SellerAnalytics from "./SellerAnalytics";
import SellerProfile from "./SellerProfile";
// Importing your existing profile API to make the header dynamic
import { getSellerProfile } from "../../api/sellerProfile.api";
import { useAuth } from "../../context/AuthContext";
import StatusBadge from "../../components/StatusBadge";
import { Tooltip } from "reactstrap";

const SellerDashboard = () => {
  const [activeTab, setActiveTab] = useState("analytics");
  const { user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);
  const [tooltips, setTooltips] = useState({
    addProduct: false,
    viewProfile: false,
    rfqTab: false,
    productsTab: false,
    analyticsTab: false
  });

  const toggleTooltip = (tooltipName) => {
    setTooltips(prev => ({
      ...prev,
      [tooltipName]: !prev[tooltipName]
    }));
  };


  const sellerInfo = user || {};


  const renderTab = () => {
    if (activeTab === "products") return <SellerProducts />;
    if (activeTab === "rfqs") return <SellerRFQs />;
    if (activeTab === "analytics") return <SellerAnalytics />;
  };

  // --- STYLES ---
  const tabBtnStyle = (isActive) => ({
    padding: "8px 24px",
    fontSize: "clamp(12px, 1.2vw, 13px)",
    fontWeight: "600",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
    backgroundColor: isActive ? "#ffffff" : "transparent",
    color: isActive ? "#112347" : "#6b7280",
    boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
    whiteSpace: "nowrap"
  });

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", padding: "clamp(15px, 4vw, 40px)" }}>
      <style>{`
        .view-profile-btn {
          background-color: #fff;
          color: #112347;
          border: 2px solid #112347;
          transition: all 0.2s ease;
        }
        .view-profile-btn:hover {
          background-color: #112347;
          color: #fff;
        }
      `}</style>
      {showProfile ? (
        <SellerProfile onBack={() => setShowProfile(false)} />
      ) : (
        <>
          {/* HEADER SECTION - NOW DYNAMIC */}
          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <h2 className="fw-bold m-0" style={{ color: "#112347", fontSize: "clamp(20px, 3vw, 28px)" }}>
                {sellerInfo.business_name}
              </h2>
              {/* Dynamic Badge Logic */}
              <StatusBadge status={sellerInfo.verification_status} /> 
            </div>
            <p className="text-muted mt-1" style={{ fontSize: "clamp(13px, 1.5vw, 16px)" }}>Manage your inquiries, RFQs, products & business performance</p>
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 gap-md-3 mb-4 mb-md-5">
            <button
              id="addProductBtn"
              className="btn btn-dark flex-grow-1"
              style={{ 
                backgroundColor: "#112347", 
                padding: "10px 16px", 
                fontWeight: "600",
                fontSize: "clamp(12px, 1.5vw, 14px)",
                minWidth: "auto",
                whiteSpace: "nowrap"
              }}
              onClick={() => setActiveTab("products")}
            >
              <span style={{ fontSize: '16px' }}>+</span> Add New Product
            </button>
            <Tooltip placement="bottom" isOpen={tooltips.addProduct} target="addProductBtn" toggle={() => toggleTooltip('addProduct')}>
              Create and list a new product
            </Tooltip>
            <button
              id="viewProfileBtn"
              className="btn flex-grow-1 view-profile-btn"
              style={{ 
                padding: "10px 16px", 
                fontWeight: "600",
                fontSize: "clamp(12px, 1.5vw, 14px)",
                minWidth: "auto",
                whiteSpace: "nowrap",
                cursor: "pointer"
              }}
              title="Edit your business profile"
              onClick={() => setShowProfile(true)}
            >
              View Company Profile
            </button>
          </div>

          {/* PILL NAVIGATION */}
          <div 
            className="d-flex gap-2 p-2 mb-4 flex-wrap" 
            style={{ 
              backgroundColor: "#f3f4f6", 
              borderRadius: "10px", 
              width: "100%",
              overflowX: "auto", 
              WebkitOverflowScrolling: "touch",
              scrollBehavior: "smooth"
            }}
          >
            <button id="rfqTab" style={tabBtnStyle(activeTab === "rfqs")} onClick={() => setActiveTab("rfqs")}>RFQs</button>
            <Tooltip placement="bottom" isOpen={tooltips.rfqTab} target="rfqTab" toggle={() => toggleTooltip('rfqTab')}>
              Manage received quotation requests
            </Tooltip>
            <button id="productsTab" style={tabBtnStyle(activeTab === "products")} onClick={() => setActiveTab("products")}>My Products</button>
            <Tooltip placement="bottom" isOpen={tooltips.productsTab} target="productsTab" toggle={() => toggleTooltip('productsTab')}>
              View and manage your product listings
            </Tooltip>
            <button id="analyticsTab" style={tabBtnStyle(activeTab === "analytics")} onClick={() => setActiveTab("analytics")}>Analytics</button>
            <Tooltip placement="bottom" isOpen={tooltips.analyticsTab} target="analyticsTab" toggle={() => toggleTooltip('analyticsTab')}>
              View your business performance metrics
            </Tooltip>
          </div>

          {/* CONTENT */}
          <div className="mt-4">{renderTab()}</div>
        </>
      )}
    </div>
  );
};

export default SellerDashboard;